import { inject, observer } from "mobx-react";
import React, { useMemo, useEffect } from "react";
import BroadcastStore from "../../_stores/broadcast/BroadcastStore";
import BroadcastC2cViewer from "./broadcast-c2c-viewer";
import "./style.scss";
import WebRTCPlayer from "common/broadcast/webrtc-player";
import { WebRTCStatus } from "common/broadcast/_stores/broadcast/enums";
import config from "core/config";
import { LiveKitCam2Cam } from "containers/livekit/Cam2Cam";
import ProfileStore from "common/my-page/stores/profile/ProfileStore";

interface Props {
  broadcastStore?: BroadcastStore;
  profileStore?: ProfileStore;
}

const BroadcastC2CList: React.FunctionComponent<Props> = ({
  broadcastStore,
  profileStore,
}) => {
  const { setWebRTCStatus } = broadcastStore!;
  const { profile } = profileStore!;

  const c2cList = useMemo(() => {
    return Object.values(broadcastStore?.c2cHash || {});
  }, [broadcastStore?.c2cHash]);

  useEffect(() => {
    if (!config.disableWebrtcC2CVideo && c2cList.length === 0)
      setWebRTCStatus(WebRTCStatus.Stopped);
  }, [c2cList]);

  useEffect(() => {
    console.log("TEST env var", config);
  }, [config]);

  if (c2cList.length === 0) {
    return null;
  }
  return (
    <div className='BroadcastC2CList'>
      {c2cList.map(c2c => {
        if (c2c.isLivekit) {
          return (
            <LiveKitCam2Cam
              key={c2c.memberId}
              userName={profile.username}
              userId={profileStore!.broadcastId!}
              memberName={c2c.memberName}
              room={`${c2c.memberName}+${profile.username}`.toLocaleLowerCase()}
              onDisconnect={() => {}}
              onSuccess={() => {}}
              onFail={() => {}}
            />
          );
        }
        if (config.disableWebrtcC2CVideo) {
          return <BroadcastC2cViewer key={`${c2c.memberId}`} c2c={c2c} />;
        }
        return <WebRTCPlayer key={`${c2c.memberId}`} c2c={c2c} />;
      })}
    </div>
  );
};

export default inject(
  "broadcastStore",
  "profileStore"
)(observer(BroadcastC2CList));
